import { IInsightWidget, OfferSubType, Severity, TypeMapper, WidgetType } from '@jumpstart/core';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { headerCase } from 'change-case';
import React from 'react';
import ContentField from './ContentField';

export interface IWidgetMeta {
  classes: any;
  index: number;
  widget: IInsightWidget;
  handleChange: any;
  setFieldValue: any;
}

function WidgetMetaBasic(props: IWidgetMeta & { options: string[]; metaName: string }) {
  const { classes, index, widget, handleChange, setFieldValue, options, metaName } = props;

  return (
    <Grid container direction="column">
      <Grid container direction="row" wrap="nowrap" sx={classes.input}>

        <Autocomplete
          sx={classes.input}
          classes={{
            // option: classes.option,
          }}
          onChange={(event, newValue) => {
            console.log('CHANGE', newValue);
            setFieldValue(`widgets[${index}].meta.subtype`, newValue);
          }}
          autoHighlight
          options={[
            'UNKNOWN',
            ...options
              .filter(t => t !== 'UNKNOWN')
              .sort((a: string, b: string) => a.localeCompare(b))
          ]}
          value={widget.meta && widget.meta.subtype ? widget.meta.subtype : OfferSubType.UNKNOWN}
          disableClearable
          getOptionLabel={(option: string) => headerCase(option)}
          renderOption={(props, option: string) => headerCase(option)}
          renderInput={(params) => (
            <TextField
              {...params}
              id={`widgets[${index}].meta.subtype`}
              name={`widgets[${index}].meta.subtype`}
              label={`${metaName}`}
              variant="outlined"
              value={widget.meta && widget.meta.subtype ? widget.meta.subtype : OfferSubType.UNKNOWN}
              inputProps={{
                ...params.inputProps,
                autoComplete: 'off'
                // autoComplete: 'new-password' // disable autocomplete and autofill
              }}
            />
          )}
        />

        <TextField
          sx={classes.input}
          key={`widgets[${index}].meta.severity`}
          id={`widgets[${index}].meta.severity`}
          name={`widgets[${index}].meta.severity`}
          label="Severity"
          defaultValue={widget.meta && widget.meta.severity ? widget.meta.severity : Severity.MINOR}
          onBlur={handleChange}
          helperText="Level of importance of this widget"
          select
          variant="outlined"
        >
          {
            Object.keys(Severity)
              .map((key: string) => <MenuItem
                  key={`widgets[${index}].meta.severity.${key}`}
                  value={key}
                >
                  {headerCase(key)}
                </MenuItem>
              )
          }
        </TextField>
      </Grid>

      <ContentField
        name={`widgets[${index}].meta.action`}
        id={`widgets[${index}].meta.action`}
        key={`widgets[${index}].meta.action`}
        label="Action text"
        defaultValue={widget.meta && widget.meta.action ? widget.meta.action : `Don't have any? We can help you!`}
        onBlur={handleChange}
        sx={classes.input}
        variant="outlined"
        placeholder="Action"
        touched={true}
        validation={{}}
        error={false}
        multiline
      />
    </Grid>
  );
}

function WidgetMetaDefault(props: IWidgetMeta) {
  const { classes, index, widget, handleChange } = props;
  return (
    <Grid container direction="row" wrap="nowrap" sx={classes.input}>
      <TextField
        sx={classes.input}
        key={`widgets[${index}].meta.severity`}
        id={`widgets[${index}].meta.severity`}
        name={`widgets[${index}].meta.severity`}
        label="offer severity"
        value={widget.meta && widget.meta.severity ? widget.meta.severity : Severity.MINOR}
        onChange={handleChange}
        select
        variant="outlined"
      >
        {
          Object.keys(Severity)
            .map((key: string) => <MenuItem
                key={`widgets[${index}].meta.severity.${key}`}
                value={key}
              >
                {headerCase(key)}
              </MenuItem>
            )
        }
      </TextField>
    </Grid>
  );
}

export default function WidgetMetaField(props: IWidgetMeta) {
  const { widget } = props;

  switch (widget.widget) {
    case WidgetType.PRODUCT:
      return (
        <WidgetMetaBasic {...props} options={TypeMapper.types('product')} metaName={'Product Type'}/>
      );
    case WidgetType.SERVICE:
      return (
        <WidgetMetaBasic {...props} options={TypeMapper.types('service')} metaName={'Service Type'}/>
      );
    case WidgetType.DIGITAL:
      return (
        <WidgetMetaBasic {...props} options={['CLICKER']} metaName={'Type'}/>
      );
    default:
      return (
        <WidgetMetaDefault {...props}/>
      );

  }
}
